module.exports = __webpack_public_path__ + "img/contest-logo-ro.27241343.png";